import { LayoutProps } from 'types/global';

import Image from 'molecules/Image';
import Link from 'molecules/Link';

import HeaderButtons from 'layout/header/components/HeaderButtons';
import Navigation from 'layout/header/components/Navigation';
import MobileNavigation from 'layout/header/components/mobileNavigation';

import type { FC } from 'react';

const Header: FC<HeaderProps> = ({ navigation, callToActions, loginLink }) => (
  <>
    <div className="mx-auto w-full max-w-screen-xl px-4 sm:px-16 lg:px-8">
      <div className="relative flex h-18 w-full items-center justify-between gap-6 lg:h-20 lg:py-5">
        <div className="w-[140px]">
          <Link href="/" enablePreview={false}>
            <Image
              url="/prismatic-logo.svg"
              width={140}
              height={29}
              alt="Prismatic logo"
              noFill
              priority
              className="h-auto w-full object-contain"
            />
          </Link>
        </div>
        <Navigation menuItems={navigation} />
        <HeaderButtons callToAction={callToActions} loginLink={loginLink} />
      </div>
    </div>
    <MobileNavigation menuItems={navigation} callToAction={callToActions} loginLink={loginLink} />
  </>
);

export const HeaderWithBuilder = ({ content }: LayoutProps) => (
  <header className="dark sticky top-0 z-[999] h-18 bg-gray-900 lg:h-20">
    <Header {...content?.data} />
  </header>
);

export default Header;
